import { render, staticRenderFns } from "./createAccount.vue?vue&type=template&id=6e8a3d8c&scoped=true"
import script from "./createAccount.vue?vue&type=script&lang=js"
export * from "./createAccount.vue?vue&type=script&lang=js"
import style0 from "./createAccount.vue?vue&type=style&index=0&id=6e8a3d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a3d8c",
  null
  
)

export default component.exports